import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/Section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0 bg-transparent'], {
  variants: {
    variant: {
      sm: 'pt-[3rem] group-[.modal]:pt-[1.5rem]',
      md: 'pt-[6rem] group-[.modal]:pt-[3rem]',
      lg: 'pt-[9rem] group-[.modal]:pt-[4.5rem]',
      xl: 'pt-[12rem] group-[.modal]:pt-[6rem]',
      xxl: 'pt-[24rem] group-[.modal]:pt-[12rem]'
    }
  },
  defaultVariants: {
    variant: 'md'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, className }))}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
